<div class="project-card">

  <div class="project-header">
    <h1 class="project-title">
      <a href="{{diligenceItem?.dealUrl}}" target="_blank" class="meta-link">{{diligenceItem?.name}}</a>
      <span class="project-address">{{diligenceItem?.address}}</span>
    </h1>

    <div class="project-meta">
      <div class="meta-row">
        <span class="meta-item"><span class="meta-icon">📈</span> Status:
        @if (diligenceItem?.status==null) {
          <strong>N/A</strong>
        }
        @if ($safeNavigationMigration(diligenceItem?.status)!==null) {
          <strong>{{diligenceItem?.status}}</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">$ LT Equity:
        @if (diligenceItem?.lt_equity==null) {
          <strong>N/A</strong>
        }
        @if ($safeNavigationMigration(diligenceItem?.lt_equity)!==null) {
          <strong>
            {{diligenceItem.lt_equity | currency: 'USD' : 'symbol' : '1.0-0'}}
          </strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">$ NOI:
        @if (diligenceItem?.noi==null) {
          <strong>N/A</strong>
        }
        @if ($safeNavigationMigration(diligenceItem?.noi)!==null) {
          <strong>
            {{diligenceItem.noi | currency: 'USD' : 'symbol' : '1.0-0'}}
          </strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">📅 LOI Signed:
        @if (diligenceItem.loi_signed_date==null) {
          <strong>N/A</strong>
        }
        @if (diligenceItem.loi_signed_date!==null) {
          <strong>{{diligenceItem.loi_signed_date | date : 'MM/dd/yyyy'}}</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">📅 Screening Committee:
        @if (diligenceItem.screening_date==null) {
          <strong>N/A</strong>
        }
        @if (diligenceItem.screening_date!==null) {
          <strong>{{diligenceItem.screening_date | date: 'MM/dd/yyyy'}}</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">📅 Capital Committee:
        @if (diligenceItem.capital_date==null) {
          <strong>N/A</strong>
        }
        @if (diligenceItem.capital_date!==null) {
          <strong>{{diligenceItem.capital_date | date: 'MM/dd/yyyy'}}</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">📅 Closed:
        @if (diligenceItem.closed_date==null) {
          <strong>N/A</strong>
        }
        @if (diligenceItem.closed_date!==null) {
          <strong>{{diligenceItem.closed_date | date: 'MM/dd/yyyy'}}</strong>
        }
      </span>
    </div>
    <div class="meta-row">
      <span class="meta-item">🏛 Fund: @if (diligenceItem?.fund==null) {
        <strong>N/A</strong>
        }@if ($safeNavigationMigration(diligenceItem?.fund)!==null) {
        <a href="{{diligenceItem.fundUrl}}" class="meta-link" target="_blank">
        {{diligenceItem?.fund}}</a>
      }</span>
      <span class="meta-divider">|</span>
      <span class="meta-item">📄 Sponsor:
        @if ($safeNavigationMigration(diligenceItem?.sponsor)!==null) {
          <a href="{{diligenceItem.sponsorUrl}}" class="meta-link" target="_blank">{{diligenceItem?.sponsor}}</a>
        }
        @if (diligenceItem?.sponsor==null) {
          <strong>N/A</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">👤 Account Manager:
        @if ($safeNavigationMigration(diligenceItem?.acc_manager)!==null) {
          <a href="{{diligenceItem?.acc_managerUrl}}" class="meta-link" target="_blank">{{diligenceItem?.acc_manager}}</a>
        }
        @if (diligenceItem?.acc_manager==null) {
          <strong>N/A</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">👤 Closing Coordinator:
        @if ($safeNavigationMigration(diligenceItem?.closing_coordinator)!==null) {
          <a href="{{diligenceItem?.closing_coordinatorUrl}}" class="meta-link" target="_blank">{{diligenceItem?.closing_coordinator}}</a>
        }
        @if (diligenceItem?.closing_coordinator==null) {
          <strong>N/A</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">👤 Underwriter:
        @if ($safeNavigationMigration(diligenceItem?.underwriter)!==null) {
          <a href="{{diligenceItem?.underwriterUrl}}" class="meta-link" target="_blank">{{diligenceItem?.underwriter}}</a>
        }
        @if (diligenceItem?.underwriter==null) {
          <strong>N/A</strong>
        }
      </span>
    </div>
    <div class="meta-row">
      <span class="meta-item">👤 Underwriting Analyst:
        @if ($safeNavigationMigration(diligenceItem?.uw_analyst)!==null) {
          <a href="{{diligenceItem?.uw_analystUrl}}" class="meta-link" target="_blank">{{diligenceItem?.uw_analyst}}</a>
        }
        @if (diligenceItem?.uw_analyst==null) {
          <strong>N/A</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">👤 Construction Analyst:
        @if ($safeNavigationMigration(diligenceItem?.construction_analyst)!==null) {
          <a href="{{diligenceItem?.construction_analystUrl}}" class="meta-link" target="_blank">{{diligenceItem?.construction_analyst}}</a>
        }
        @if (diligenceItem?.construction_analyst==null) {
          <strong>N/A</strong>
        }
      </span>
      <span class="meta-divider">|</span>
      <span class="meta-item">🔗 <a href="{{diligenceItem.sharepointUrl}}" class="meta-link" target="_blank">Sharepoint Link</a></span>
    </div>
  </div>
</div>

<div class="panels-row">
  <div class="panel dates-panel">
    <h3 class="panel-title">Dates</h3>
    <div class="panel-body">
      @for (d of dates; track d) {
        <div class="date-row" [class.date-row--alert]="d.alert">
          <span class="date-label">{{ d.label }}</span>
          <span class="date-value">{{ d.date.includes('-') ? (d.date | date: 'MM/dd/yyyy') : d.date }}</span>
        </div>
      }
    </div>
  </div>

  @for (panel of (ddService.checklists$ | async); track panel) {
    <div class="panel">
      <h3 class="panel-title">{{ panel.name }}</h3>
      <div class="panel-body">
        <mat-accordion multi>
          @for (item of panel.ddChecklistItems; track item) {
            <mat-expansion-panel
              [expanded]="false"
              class="tracker-item-panel">
              <!-- Panel Header -->
              <mat-expansion-panel-header>
                <mat-panel-title class="tracker-header">
                  <span class="status-icon"
                      [ngClass]="{
                        'status-icon--approved': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'approved',
                        'status-icon--received': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'received',
                         'status-icon--ordered': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'ordered',
                         'status-icon--draft-complete': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'draft completed',
                         'status-icon--draft-questions': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'draft questions',
                         'status-icon--draft-received': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'draft received',
                         'status-icon--ready-to-order': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'ready to order',
                         'status-icon--update-in-progress': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'update in progress',
                         'status-icon--questions': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'questions',
                        'status-icon--empty': getSelectionForItem(item)?.ddChecklistState?.name.toLowerCase() === 'outstanding' ||
                        getSelectionForItem(item) == null
                      }">
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'approved') {
                      <mat-icon class="status-mat-icon">check</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'draft completed') {
                      <mat-icon class="status-mat-icon--green">text_snippet</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'draft questions') {
                      <mat-icon class="status-mat-icon--yellow">help_center</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'draft received') {
                      <mat-icon class="status-mat-icon--lightblue">inbox</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'update in progress') {
                      <mat-icon class="status-mat-icon--orange">update</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'ready to order') {
                      <mat-icon class="status-mat-icon--purple">adjust</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'received') {
                      <mat-icon class="status-mat-icon">arrow_downward</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'ordered') {
                      <mat-icon class="status-mat-icon">access_time</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'questions') {
                      <mat-icon class="status-mat-icon">question_mark</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'not applicable') {
                      <mat-icon class="status-mat-icon--black">not_interested</mat-icon>
                    }
                    @if (getSelectionForItem(item)?.ddChecklistState.name.toLowerCase() === 'outstanding' || getSelectionForItem(item)==null) {
                      <mat-icon class="status-mat-icon">circle</mat-icon>
                    }
                  </span>
                  <span class="tracker-name">{{ item.name }}</span>
                </mat-panel-title>
                <mat-panel-description class="tracker-date">
                  {{ ($safeNavigationMigration(getDateForSelectionItem(getSelectionForItem(item)?.projectDdChecklistDates ?? [])?.date) | date: 'MM/dd/yyyy') || '' }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <!-- Expanded Content -->
              @if (getItemForm(item); as form) {
                <div class="tracker-content">
                  <!-- Status Select -->
                  <div class="form-section" [formGroup]="$any(form)">
                    <label class="form-label">SELECT A NEW STATUS</label>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-select formControlName="status" (selectionChange)="changeStatus(item, $event)">
                        @for (status of (ddService.statuses$ | async); track status) {
                          <mat-option [value]="status.id">{{ status.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Past Dates -->
                  <div class="form-section">
                    <div class="section-header">
                      <label class="form-label">PAST DATES</label>
                      <button mat-button color="primary" class="add-btn" (click)="openAddDateModal(item)">ADD</button>
                    </div>
                    @for (pd of getPastDatesArray(item).controls; track pd; let i = $index) {
                      <div class="past-date-row" [formGroup]="$any(pd)">
                        <span class="past-date-label">{{ pd.get('statusName')?.value }}</span>
                        <mat-form-field appearance="outline" class="date-field">
                          <input matInput formControlName="date" placeholder="mm/dd/yyyy" [matDatepicker]="picker">
                          <mat-datepicker-toggle
                            matIconSuffix
                          [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        @if ((ddService.permissions$ | async)?._edit) {
                          <button mat-icon-button class="delete-date-btn" (click)="removeProjectDdStatusDate($safeNavigationMigration(pd.get('id')?.value), item)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  </div>
                  <!-- Additional Dates (collapsible) -->
                  @if (getAdditionalDatesArray(item).length) {
                    <mat-expansion-panel class="additional-dates-panel">
                      <mat-expansion-panel-header>
                        <mat-panel-title class="form-label">ADDITIONAL DATES</mat-panel-title>
                      </mat-expansion-panel-header>
                      @for (ad of getAdditionalDatesArray(item).controls; track ad) {
                        <div class="additional-date-row" [formGroup]="$any(ad)">
                          <span class="additional-date-label">{{ ad.get('name')?.value }}</span>
                          <mat-form-field appearance="outline" class="date-field">
                            <input matInput formControlName="date" placeholder="mm/dd/yyyy" [matDatepicker]="additionalPicker">
                            <mat-datepicker-toggle
                              matIconSuffix
                            [for]="additionalPicker"></mat-datepicker-toggle>
                            <mat-datepicker #additionalPicker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                  <!-- Save Button -->
                  <div class="save-row">
                    @if ((ddService.permissions$ | async)?._edit) {
                      <button mat-raised-button color="primary" class="save-btn" (click)="selectionSave(getSelectionForItem(item), item)">SAVE</button>
                    }
                  </div>
                </div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
  }

</div>

<!-- ═══ Timing Issues Section ═══ -->
<div class="timing-section">
  <h3 class="timing-title">Timing Issues</h3>
  <div class="row">
    <mat-form-field>
      <textarea matInput name="timing_issues" type="text" [formControl]="timingFormControl"></textarea>
    </mat-form-field>
  </div>
  <div class="timing-body">
    <span class="timing-label">Timing Delay:</span>
    <mat-form-field>
      <input matInput type="number" class="timing-input" [formControl]="timingDelay">
    </mat-form-field>
    <span class="timing-unit">days</span>
    <mat-checkbox class="timing-checkbox" [formControl]="highPriority">High Priority</mat-checkbox>
  </div>
</div>

<!-- ═══ Footer ═══ -->
<div class="card-footer">
  @if ((ddService.permissions$ | async)?._edit) {
    <button mat-raised-button color="primary" (click)="updateProjectDdGroup()">SAVE</button>
  }
</div>

</div>
